import { gql } from 'graphql-request'

const GET_CREATORS_COUNT = gql`
  query getCreatorsCount(
    $search: String
    $type: String
    $creator_categories: [bigint!]
  ) {
    creators_aggregate(
      where: {
        _and: [
          { account_status: { _eq: "active" } }
          { deleted: { _nin: ["true"] } }
          { products: { status: { _eq: "active" } } }
          { creator_category_id: { _in: $creator_categories } }
          { _or: [{ nickname: { _ilike: $search } }] }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export default GET_CREATORS_COUNT
